import { render, staticRenderFns } from "./ResetPasswordForm.vue?vue&type=template&id=a550d3c0"
import script from "./ResetPasswordForm.vue?vue&type=script&lang=js"
export * from "./ResetPasswordForm.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordForm.vue?vue&type=style&index=0&id=a550d3c0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports